var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "scrap-step-wrap" }, [
    _c("div", { staticClass: "go-modal-inner overflow-y-scroll" }, [
      _c("fieldset", { staticClass: "go-fieldset scrap-step-contents" }, [
        _c("div", { staticClass: "go-form-group" }, [
          _c("label", { staticClass: "go-form-label" }, [
            _vm._v(_vm._s(_vm.$t("scrap-agent.name"))),
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.formDataStep1.briefingTitle,
                expression: "formDataStep1.briefingTitle",
              },
            ],
            staticClass: "go-form-control",
            attrs: { type: "text" },
            domProps: { value: _vm.formDataStep1.briefingTitle },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.formDataStep1,
                  "briefingTitle",
                  $event.target.value
                )
              },
            },
          }),
          _vm._v(" "),
          _vm.isDuplicate
            ? _c("div", { staticClass: "go-form-feedback" }, [
                _c("div", { staticClass: "go-form-feedback-invalid" }, [
                  _vm._v("Duplicate agent name! Please try again."),
                ]),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "go-form-group" }, [
          _c("label", { staticClass: "go-form-label" }, [
            _vm._v(_vm._s(_vm.$t("scrap-agent.description"))),
          ]),
          _vm._v(" "),
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.formDataStep1.briefingDescription,
                expression: "formDataStep1.briefingDescription",
              },
            ],
            staticClass: "go-form-control",
            attrs: { rows: "3" },
            domProps: { value: _vm.formDataStep1.briefingDescription },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.formDataStep1,
                  "briefingDescription",
                  $event.target.value
                )
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "go-form-group" }, [
          _c("label", { staticClass: "go-form-label" }, [
            _vm._v(_vm._s(_vm.$t("scrap-agent.settings"))),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "custom-control custom-radio go-form-check-inline" },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formDataStep1.briefingPrivacy,
                    expression: "formDataStep1.briefingPrivacy",
                  },
                ],
                staticClass: "custom-control-input",
                attrs: {
                  type: "radio",
                  id: "go-option-public",
                  name: "privacy",
                  value: "PUBLIC",
                },
                domProps: {
                  checked: _vm._q(_vm.formDataStep1.briefingPrivacy, "PUBLIC"),
                },
                on: {
                  change: function ($event) {
                    return _vm.$set(
                      _vm.formDataStep1,
                      "briefingPrivacy",
                      "PUBLIC"
                    )
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "custom-control-label",
                  attrs: { for: "go-option-public" },
                },
                [_vm._v(_vm._s(_vm.$t("scrap-agent.public")))]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "custom-control custom-radio go-form-check-inline" },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formDataStep1.briefingPrivacy,
                    expression: "formDataStep1.briefingPrivacy",
                  },
                ],
                staticClass: "custom-control-input",
                attrs: {
                  type: "radio",
                  id: "go-option-private",
                  name: "privacy",
                  value: "PRIVATE",
                },
                domProps: {
                  checked: _vm._q(_vm.formDataStep1.briefingPrivacy, "PRIVATE"),
                },
                on: {
                  change: function ($event) {
                    return _vm.$set(
                      _vm.formDataStep1,
                      "briefingPrivacy",
                      "PRIVATE"
                    )
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "custom-control-label",
                  attrs: { for: "go-option-private" },
                },
                [_vm._v(_vm._s(_vm.$t("scrap-agent.private")))]
              ),
            ]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }